<template>
  <div class="flex flex-wrap mt-4">
    <div class="w-full mb-12 px-4">
      <card-record
        title="Presupuesto"
        resource="proyectos"
        primaryKey="idpresupuesto"
        :record="record"
        :columns="columns"
        @saveChanges="handleSave"
        :service="service"
        :readonly="readonly"
      >
        <template v-slot:actions v-if="!readonly">
          <button
            class="bg-yellow-500 text-white font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
            type="button"
            @click="calcularCostoEngapa()"
          >
            {{ $t("Descargar horas") }}
          </button>
        </template>
      </card-record>
    </div>
    <div class="w-full mb-12 px-4" v-if="!isNew">
      <div
        class="text-sm font-medium text-center text-gray-500 border-b border-gray-200 mb-3"
      >
        <ul
          class="flex flex-wrap text-sm font-medium text-center text-gray-500 border-b border-gray-200"
        >
          <li class="me-2">
            <button
              @click="openTab('horasPorPersona')"
              class="inline-block p-4 rounded-t-lg"
              :class="[
                tabName === 'horasPorPersona'
                  ? 'active text-blue-600 bg-gray-100'
                  : 'hover:text-gray-600 hover:bg-gray-50',
              ]"
            >
              {{ $t("Horas por personal") }}
            </button>
          </li>
          <li class="me-2">
            <button
              @click="openTab('horasPorTarea')"
              class="inline-block p-4 rounded-t-lg"
              :class="[
                tabName === 'horasPorTarea'
                  ? 'active text-blue-600 bg-gray-100'
                  : 'hover:text-gray-600 hover:bg-gray-50',
              ]"
            >
              {{ $t("Horas por tarea") }}
            </button>
          </li>
          <li class="me-2" v-if="isAdmin">
            <button
              @click="openTab('transacciones')"
              class="inline-block p-4 rounded-t-lg"
              :class="[
                tabName === 'transacciones'
                  ? 'active text-blue-600 bg-gray-100'
                  : 'hover:text-gray-600 hover:bg-gray-50',
              ]"
            >
              {{ $t("Transacciones") }}
            </button>
          </li>
        </ul>
      </div>

      <card-list
        :title="relatedList.title"
        :primaryKey="relatedList.primaryKey"
        :resource="relatedList.resource"
        :records="relatedList.records"
        :meta="relatedList.meta"
        :columns="relatedList.columns"
        :hideFilters="tabName !== 'transacciones'"
        :readonly="tabName !== 'transacciones'"
      >
        <template v-slot:actions>
          <filter-stats />
        </template>
        <template v-slot:after-table v-if="tabName === 'transacciones'">
          <card-list
            title="Totales entre filtros aplicados en USD"
            :records="transaccionTotalRecords"
            :columns="transaccionTotalColumns"
            readonly="true"
            hideFilters="true"
            doNotSort="true"
            unableSelect="true"
            hideHeaders="true"
            hideActions="true"
          />
        </template>
        <template v-slot:tfoot v-if="tabName !== 'transacciones'">
          <tfoot>
            <tr class="border-t">
              <td
                class="border-t-0 px-6 align-middle border-l-0 border-r-0 text-sm whitespace-nowrap p-4"
              >
                <strong> Total </strong>
              </td>
              <td
                class="border-t-0 px-6 align-middle border-l-0 border-r-0 text-sm whitespace-nowrap p-4"
              >
                <strong>
                  {{ relatedList.total }}
                </strong>
              </td>
              <td></td>
            </tr>
          </tfoot>
        </template>
      </card-list>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { useToast } from "vue-toastification";
import CardRecord from "@/components/Cards/CardRecord.vue";
import CardList from "@/components/Cards/CardList.vue";
import FilterStats from "@/components/Forms/FilterStats.vue";
import PresupuestoService from "@/services/presupuesto.service";
import ReporteService from "@/services/reporte.service";
import TransaccionService from "@/services/transaccion.service";
import { presupuesto } from "@/models/presupuesto";
import { transaccion } from "@/models/transaccion";
import { descargarCSV } from "@/utils/descargas";

export default {
  components: {
    CardRecord,
    CardList,
    FilterStats,
  },

  data() {
    return {
      record: {},
      columns: presupuesto,
      service: PresupuestoService,
      tabName: "horasPorPersona",
      transaccionTotalColumns: [
        { name: "label", type: "STRING" },
        { name: "value", type: "DECIMAL", currency: true },
      ],
      relatedListInfo: {
        horasPorPersona: {
          title: this.$t("Horas por personal"),
          primaryKey: "idpersonal",
          resource: "personal",
          columns: [
            {
              label: "Personal",
              name: "nombre",
              type: "STRING",
            },
            {
              label: "Horas",
              name: "horas",
              type: "DECIMAL",
            },
          ],
        },
        horasPorTarea: {
          title: this.$t("Horas por tarea"),
          primaryKey: "idtarea",
          resource: "tareas",
          columns: [
            {
              label: "Tarea",
              name: "nombre",
              type: "STRING",
            },
            {
              label: "Horas",
              name: "horas",
              type: "DECIMAL",
            },
          ],
        },
        transacciones: {
          title: this.$t("Transacciones"),
          primaryKey: "idtransaccion",
          resource: "transacciones",
          records: [],
          meta: {},
          columns: transaccion.filter(
            (column) => column.showOnList && column.name !== "idpresupuesto",
          ),
        },
      },
    };
  },

  watch: {
    $route: {
      immediate: true,
      handler(/*to, from*/) {
        // Record
        PresupuestoService.get(this.idpresupuesto)
          .then((data) => {
            this.record = data.record;
          })
          .catch((response) => {
            console.log(response);
          });

        // Solo carga la tab activa
        this.loadCurrentTab();
        ["startDateFromState", "endDateFromState"].forEach((property) => {
          this.$watch(
            () => this[property],
            () => {
              this.loadCurrentTab();
            },
          );
        });
      },
    },
  },

  computed: {
    ...mapState({
      userInfo: (state) => state.auth.user,
      startDateFromState: (state) => state.filters.startDate,
      endDateFromState: (state) => state.filters.endDate,
    }),

    idpresupuesto() {
      return this.$route.params.id;
    },

    isNew() {
      return this.idpresupuesto == "new";
    },

    readonly() {
      const roles = this.userInfo?.roles || [];
      return !roles.includes("admin") && !roles.includes("personal");
    },

    relatedList() {
      return this.relatedListInfo[this.tabName] || {};
    },

    isAdmin() {
      return this.userInfo?.roles?.includes("admin");
    },

    transaccionTotalRecords() {
      const meta = this.relatedListInfo.transacciones.meta;
      const ingresos = meta.totalIngresos || 0;
      const ivaIngresos = meta.totalIVAIngresos || 0;
      const egresos = meta.totalEgresos || 0;
      const ivaEgresos = meta.totalIVAEgresos || 0;
      const saldo = ingresos - egresos;
      const saldoIVA = ivaEgresos - ivaIngresos;
      return [
        { label: "Ingresos", value: ingresos },
        { label: "Egresos", value: egresos },
        { label: "Saldo", value: saldo || 0 },
        { label: "IVA Ingresos", value: ivaIngresos },
        { label: "IVA Egresos", value: ivaEgresos },
        { label: saldoIVA > 0 ? "IVA a favor" : "IVA a pagar", value: Math.abs(saldoIVA) },
      ];
    },
  },

  methods: {
    handleSave(record) {
      this.record = record;
    },

    openTab(newTabName) {
      this.$router.push({ query: {} })
        .catch(() => {})
        .then(() => {
          this.tabName = newTabName;
          this.loadCurrentTab();
        });
    },

    loadCurrentTab() {
      if (this.isNew) return;
      // undefined = FilterStats aún no inicializó; null = histórico (sin filtro de fechas)
      if (
        this.startDateFromState === undefined ||
        this.endDateFromState === undefined
      ) {
        return;
      }
      if (this.tabName === "horasPorPersona") this.loadHorasPorPersona();
      else if (this.tabName === "horasPorTarea") this.loadHorasPorTarea();
      else if (this.tabName === "transacciones") this.loadTransacciones();
    },

    loadHorasPorPersona() {
      const idpresupuesto = this.idpresupuesto;
      const params = { ...this.$route.query, idpresupuesto };
      params.startDate = this.startDateFromState;
      params.endDate = this.endDateFromState;

      ReporteService.horasPorPersona(params)
        .then((data) => {
          const totalHoras = data.meta.totalHoras || 0;
          this.relatedListInfo.horasPorPersona.records = data.records;
          this.relatedListInfo.horasPorPersona.meta = data.meta;
          this.relatedListInfo.horasPorPersona.total = totalHoras;
        })
        .catch((response) => {
          console.log(response);
        });
    },

    loadHorasPorTarea() {
      const idpresupuesto = this.idpresupuesto;
      const params = { ...this.$route.query, idpresupuesto };
      params.startDate = this.startDateFromState;
      params.endDate = this.endDateFromState;

      ReporteService.horasPorTarea(params)
        .then((data) => {
          const totalHoras = (data.records || []).reduce(
            (sum, rec) => sum + (parseFloat(rec.horas) || 0),
            0,
          );
          this.relatedListInfo.horasPorTarea.records = data.records;
          this.relatedListInfo.horasPorTarea.meta = data.meta;
          this.relatedListInfo.horasPorTarea.total = totalHoras;
        })
        .catch((response) => {
          console.log(response);
        });
    },

    loadTransacciones() {
      const params = { ...this.$route.query };
      const transaccionFilters = JSON.parse(params.filters || "{}");
      transaccionFilters.idpresupuesto = {
        value: this.idpresupuesto,
        type: "presupuesto",
      };
      params.filters = JSON.stringify(transaccionFilters);
      params.startDate = this.startDateFromState;
      params.endDate = this.endDateFromState;

      TransaccionService.list(params)
        .then((data) => {
          this.relatedListInfo.transacciones.records = data.records;
          this.relatedListInfo.transacciones.meta = data.meta;
        })
        .catch((response) => {
          console.log(response);
        });
    },

    calcularCostoEngapa() {
      const toast = useToast();
      this.record.calcularCostoEngapa = true;
      this.service
        .upsert(this.record)
        .then((data) => {
          if (!data.record || data.error) {
            throw data;
          }

          const {
            idpresupuesto,
            idobra,
            idmoneda,
            estado,
            nombre,
            fecha_costo_engapa,
            costo_engapa,
            cobrado,
            monto_total_comparativo,
            monto_total,
            monto_horas_redibujo,
            monto_asesoramiento,
            area_intervencion,
            volumen,
            fecha_enviado,
            fecha_inicio,
            fecha_fin,
            indice1,
            indice2,
            indice3,
            indice4,
            costo_total_horas,
            costo_hora_promedio,
          } = data.record;

          this.record = {
            ...this.record,
            idpresupuesto,
            idobra,
            idmoneda,
            estado,
            nombre,
            fecha_costo_engapa,
            costo_engapa,
            cobrado,
            monto_total_comparativo,
            monto_total,
            monto_horas_redibujo,
            monto_asesoramiento,
            area_intervencion,
            volumen,
            fecha_enviado,
            fecha_inicio,
            fecha_fin,
            indice1,
            indice2,
            indice3,
            indice4,
            costo_total_horas,
            costo_hora_promedio,
          };

          toast.success("Se han actualizado los costos exitosamente");

          if (data.csv) {
            descargarCSV(
              data.csv,
              `Costo del proyecto ${this.record.nombre}.csv`,
            );
          }
        })
        .catch((response) => {
          toast.error("No se han podido actualizar los costos");
          console.error(response);
        })
        .finally(() => {
          this.record.calcularCostoEngapa = false;
        });
    },
  },
};
</script>
